const Star = () => {
  return (
    <svg
      width="30"
      height="60"
      viewBox="0 0 30 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2847_37212)">
        <path
          d="M3.011 31.8357C1.85274 31.3219 1.85274 29.6781 3.011 29.1643L13.1628 24.661C13.9204 24.3249 14.2471 23.4267 13.8824 22.6824L9.06451 12.8482C8.51089 11.7181 9.54945 10.4634 10.763 10.7961L21.5954 13.7657C22.3802 13.9808 23.1896 13.5134 23.3954 12.7261L26.1836 2.06156C26.4989 0.855765 28.0821 0.572808 28.7955 1.59475L35.7369 11.5382C35.9082 11.7835 36 12.0754 36 12.3746L36 48.6254C36 48.9246 35.9082 49.2165 35.7369 49.4618L28.7955 59.4052C28.0821 60.4272 26.4989 60.1442 26.1836 58.9384L23.3954 48.2739C23.1896 47.4866 22.3802 47.0192 21.5954 47.2343L10.763 50.2039C9.54945 50.5366 8.51089 49.2819 9.06451 48.1518L13.8824 38.3176C14.2471 37.5733 13.9204 36.6751 13.1628 36.339L3.011 31.8357Z"
          fill="#FFDF70"
        />
      </g>
      <defs>
        <clipPath id="clip0_2847_37212">
          <rect
            width="60"
            height="30"
            fill="white"
            transform="translate(0 60) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Star;
